//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from "../api/api";
import wechat from "../utils/wx";
export default {
  data() {
    return {
      swipers: {
        list: [
          {
            img: require("../assets/images/list_1_01.jpg"),
          },
          {
            img: require("../assets/images/list_1_01.jpg"),
          },
          {
            img: require("../assets/images/list_1_01.jpg"),
          },
        ],
      },
      titleAll: "全部文章",
      current: 0,
      img: require("../assets/images/list_2_04.jpg"),
      articleList: [
        {
          img: require("../assets/images/list_2_04.jpg"),
          title: "智慧税务主题沙龙1",
        },
        {
          img: require("../assets/images/list_2_04.jpg"),
          title: "智慧税务主题沙龙2",
        },
        {
          img: require("../assets/images/list_2_04.jpg"),
          title: "智慧税务主题沙龙3",
        },
      ],
      list: [],
      banner: [],
      complete: false,
      count: 0,
      nextShow: false,
      loaded: false,

      curChannelId: "", //当前频道Id
      dataSource: [], //频道数据数组
    };
  },
  mounted() {
    //          this.$emit('header')
    //          this.$ajax.get(api.list,{
    //              params:{
    //                articleType:this.$route.params.type
    //              }
    //          }).then((res) => {
    //              this.list = res['data']['items']
    //          })
    let self = this;

    if (self.$route.params.type == 0) {
      _vds.push(["setPageGroup", "MyyCaseList"]);
    } else {
      _vds.push(["setPageGroup", "MyyNewsList"]);
    }

    _vds.push(["setPS1", ""]);

    let timer = null;
    let count = 0;
    timer = setInterval(() => {
      if ("trackPV" in _vds) {
        clearInterval(timer);
        _vds.trackPV();
      }
      if (count++ > 1000) {
        clearInterval(timer);
      }
    }, 100);

    var banner_type = -1;
    if (this.$route.params.type == 0) {
      banner_type = 1; //案例
      this.getChannelList(this.getList);
    } else {
      banner_type = 2;
      this.getList();
    }

    this.$ajax
      .get(api.banner, {
        params: {
          type: banner_type,
        },
      })
      .then((res) => {
        this.banner = res["data"];
        this.complete = true;
      });

    this.$ajax
      .get(api.weixin, {
        params: {
          signurl: location.href.split("#")[0],
        },
      })
      .then((res) => {
        this.wechatExist(function () {
          let share = wechat(wx);
          share.ready(
            void 0,
            {
              link: location.href, // 分享链接
              type: "", // 分享类型,music、video或link，不填默认为link
              dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            },
            {
              page:
                self.$route.params.type == 0 ? "MyyCaseList" : "MyyNewsList",
              id: "",
            }
          );

          share.config(res["wx"]);
        });
      });
  },
  beforeDestroy() {
    this.$emit("footer", false);
  },
  methods: {
    _link(id) {
      if (id) {
        this.$router.push({
          name: "Detail",
          params: {
            id: id,
          },
        });
      }
    },
    getList() {
      var self = this;
      this.$ajax
        .get(api.list, {
          params: {
            articleType: this.$route.params.type,
            page: ++this.count,
            channelId: this.curChannelId,
          },
        })
        .then((res) => {
          this.list = this.list.concat(res["data"]["items"]);
          for (let i = 0; i < this.list.length; i++) {
            const date = this.list[i].publishTime;
            const newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date);
            let timeArr = newDate[0].split("-");
            this.list[
              i
            ].publishTime = `${timeArr[0]}年${timeArr[1]}月${timeArr[2]}日`;
          }
          this.nextShow = res["data"]["next"];

          if (this.count == 1) {
            setTimeout(() => {
              self.loaded = true;
              self.$emit("footer", true);
            }, 200);
          }
        });
    },
    getChannelList(callback) {
      this.$ajax.get(api.get_channel_list).then((res) => {
        //默认最多只显示4个
        this.dataSource = res["data"].slice(0, 4);
        //默认去一个频道Id
        this.dataSource.length > 0
          ? (this.curChannelId = this.dataSource[0].id)
          : null;
        typeof callback === "function" && callback();
      });
    },
    wechatExist(cb) {
      let timer = null;
      timer = setInterval(() => {
        if ("wx" in window) {
          clearInterval(timer);
          if (cb) {
            cb();
          }
        }
      }, 200);
    },
    onTabItemClick(item, index) {
      this.current = index;
      this.curChannelId = item.id;
      this.count = 0;
      this.list = [];
      this.getList();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/list.vue